export const POLISH = "pl";
